export const POLISH = "pl";
